import React from 'react'
import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { CircularProgress } from '@material-ui/core'

const useStyles = makeStyles({
  root: {
    color: '#00A5EE',
    textTransform: 'uppercase'
  }
})

const BarWrapper = styled.div`
  max-height: 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px
`

const StyledProgressBar = styled.div`
  width: 100%;
  height: 5px;
  background-color: #bcbccb;
  position: relative;
`

const ConcludedPercentage = styled.div`
  width: ${({ progress }) => (progress ? `${progress}%` : 0)};
  height: 5px;
  background-color: #00a5ee;
`

const ConclusionBar = ({ progress }) => {
  const classes = useStyles()

  if(progress >100){
    progress = 100
  }



  return (
    <BarWrapper>
      <Typography gutterBottom variant="body2" component="p" className={classes.root}>{`concluído ${progress}%`}</Typography>
      <StyledProgressBar>
        <ConcludedPercentage progress={progress} />
      </StyledProgressBar>
    </BarWrapper>
  )
}

ConclusionBar.defaultProps = {
  progress: 0
}

export default ConclusionBar
